import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import $ from "jquery";
import "../../resources/js/jquery.rwdImageMaps.js";
import "../../resources/css/landing.css";

const AsobiBooks = () => {
  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `특허받은 한글 동화`;

    // jQuery rwdImageMaps 초기화
    $("img[usemap]").rwdImageMaps();
	
	// react-helmet-async로 추가된 메타 태그를 최상단으로 이동
	const helmetMetaTags = document.querySelectorAll('meta[data-rh="true"]');
	helmetMetaTags.forEach(tag => {
	  document.head.prepend(tag);
	});
	
  }, []);

  return (
    <>
      <Helmet>
        <title>특허받은 한글 동화</title>
		<meta property="og:locale" content="ko_KR" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="특허받은 한글 동화" />
        <meta
          property="og:description"
          content="특허받은 한글 동화와 함께하세요!"
        />
        <meta
          property="og:image"
          content="https://spring.asobi.co.kr/custom-resources/img/asobi_books_og_v1.jpg"
        />
        <meta
          property="og:url"
          content="https://spring.asobi.co.kr/landing/asobi_books"
        />
      </Helmet>
      <body id="section">
        <div >
          <img
            src="../custom-resources/img/asobi_books_v1.jpg"
            alt=""
            border="0"
            useMap="#fairy_tale"
          />
          <map name="fairy_tale" id="fairy_tale">
            {/* 아래 주석 부분은 필요시 활성화 */}
            {/* <area shape="rect" coords="70,2530,470,2720" href="https://www.yes24.com/Product/Goods/118604709" alt="예스24-후우,바구니 타자!" target="_blank" />
            <area shape="rect" coords="471,2530,865,2720" href="https://product.kyobobook.co.kr/detail/S000201753184" alt="교보문고-후우,바구니 타자!" target="_blank" />
            <area shape="rect" coords="70,3820,470,4020" href="https://www.yes24.com/Product/Goods/119139960" alt="예스24-파도머리,보드 타자!" target="_blank" />
            <area shape="rect" coords="471,3820,865,4020" href="https://product.kyobobook.co.kr/detail/S000202384425" alt="교보문고-파도머리,보드 타자!" target="_blank" />
            <area shape="rect" coords="70,5105,470,5300" href="https://www.yes24.com/Product/Goods/119809789" alt="예스24-아기비,기차 타자!" target="_blank" />
            <area shape="rect" coords="471,5105,865,5300" href="https://product.kyobobook.co.kr/detail/S000202800230" alt="교보문고-아기비,기차 타자!" target="_blank" /> */}
          </map>
        </div>
      </body>
    </>
  );
};

export default AsobiBooks;
